<div style="padding: 24px">
    <div class="one-row">
        <span class="spacer"></span>
        <kiene-zeitauswahl [hideAggregate]="true" (change)="zeitintervalChanged($event)"></kiene-zeitauswahl>
        <span class="spacer"></span>
    </div>

    <div class="fk-options">
        <label class="fk-opt">
            <mat-checkbox [formControl]="nurFreigegebenCtrl">Nur freigegebene Belege</mat-checkbox>
            <mat-icon class="fk-info" matTooltip="Nur Belege, die für die Primanota freigegeben sind.">info</mat-icon>
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="auchOhneKostenCtrl">Fahrzeuge ohne Kosten</mat-checkbox>
            <mat-icon class="fk-info" matTooltip="Auch Autos ohne Betrag in der Liste behalten.">info</mat-icon>
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="nurAktivCtrl">Nur aktive Fahrzeuge</mat-checkbox>
            <mat-icon class="fk-info" matTooltip="Ausgemusterte Fahrzeuge (aktiv = nein) ausblenden.">info</mat-icon>
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="verteilenCtrl">Pauschalen verteilen</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="An: Stammkonto ohne Suffix (z. B. 4530) wird gleichmäßig auf alle Fahrzeuge der Liste gelegt. Aus: Rohwerte, Pauschalen stehen in der Zeile PAUSCHAL."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="tageweiseCtrl">Tageweise umlegen</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="An: Quartals-AfA/-Steuer wird anteilig auf den gewählten Zeitraum umgelegt (Juni = 30/91 von Q2). Aus: voller Belegbetrag, sobald der Zeitraum den Leistungszeitraum schneidet."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="leistungsdatumCtrl">Leistungsdatum</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="Zählt Belege, deren Leistungsdatum im Zeitraum liegt, nicht nur das Rechnungsdatum. Quartalszinsen vom 30.06. mit Leistung 01.04. erscheinen so auch in April."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="ver02TextCtrl">Steuer/Versicherung ohne Konto</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="VER02-Belege mit Kommentar „Kfz-Steuer“ oder „Versicherung PKW“ zählen als 4510/4520, auch wenn noch kein FiBu-Konto gesetzt ist."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="afaTextCtrl">AfA über Text</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="Positionstext mit 4832 / „Abschreibungen auf Fahrzeuge“ zählt als AfA, auch wenn das Konto 4830 ist (vertauschte Q2-Buchung)."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="kennzeichenKommentarCtrl">Kennzeichen im Kommentar</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="„DR-71 Kraftfahrzeug-Versicherung“ geht nur auf dieses Auto, nicht in die allgemeine Pauschale."
                >info</mat-icon
            >
        </label>
    </div>

    <table class="report-ergebnis-table" *ngIf="summen">
        <thead>
            <tr>
                <th></th>
                <th>Fahrzeuge</th>
                <th>Gesamt</th>
                <th>4510 Steuer</th>
                <th>4520 Vers.</th>
                <th>4530 Betrieb</th>
                <th>4540 Reparatur</th>
                <th>4580 Sonst.</th>
                <th>2120 Zinsen</th>
                <th>4832 AfA</th>
                <th>Belege</th>
            </tr>
        </thead>
        <tbody>
            <tr style="font-size: 1.6em; font-weight: bold; color: green">
                <td style="font-size: 1em; font-weight: bold; color: gray"></td>
                <td>{{ (summen.fahrzeuge_mit_kosten || summen.fahrzeuge) | number: "1.0-0" }}</td>
                <td>{{ summen.netto_gesamt | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4510 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4520 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4530 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4540 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4580 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_2120 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4832 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.belege | number: "1.0-0" }}</td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="loading" class="one-row" style="margin: 24px 0">
        <span class="spacer"></span>
        <mat-spinner [diameter]="36"></mat-spinner>
        <span class="spacer"></span>
    </div>

    <mat-card>
        <div class="one-row">
            <span class="spacer"></span>
            <kiene-csv-export
                [columns]="csvColumns"
                [data]="dataSource.data"
                [filename]="csvFilename"
            ></kiene-csv-export>
        </div>
        <table mat-table [dataSource]="dataSource" matSort #hauptSort="matSort">
            <ng-container matColumnDef="kennzeichen">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kennzeichen</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kennzeichen }}</td>
            </ng-container>
            <ng-container matColumnDef="bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Bezeichnung</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.bezeichnung }}</td>
            </ng-container>
            <ng-container matColumnDef="tierarzt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Tierarzt</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.tierarzt }}</td>
            </ng-container>
            <ng-container matColumnDef="kostenstelle_suffix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Suffix</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kostenstelle_suffix }}</td>
            </ng-container>
            <ng-container matColumnDef="anteil_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Anteil (%)</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.anteil_prozent | number: "1.0-2" }} %</td>
            </ng-container>
            <ng-container matColumnDef="netto_4510">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4510</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4510 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4520">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4520</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4520 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4530">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4530</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4540">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4540</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4540 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4580">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4580</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4580 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_2120">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">2120</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_2120 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4832">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4832 AfA</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4832 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_sonst">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Sonst.</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_sonst | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_gesamt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Gesamt</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_gesamt | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="belege">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Belege</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.belege | number: "1.0-0" }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div *ngIf="!loading && dataSource.data.length === 0" style="padding: 24px; color: #888; text-align: center">
            Keine Fahrzeugkosten im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-top: 24px">
        <div class="one-row" style="align-items: center; gap: 16px; flex-wrap: wrap; padding: 8px 0">
            <span style="font-weight: 500">4530 Betrieb nach Nebenkostenartikel</span>
            <span class="spacer"></span>
            <mat-checkbox [formControl]="dieselCtrl">Diesel</mat-checkbox>
            <mat-checkbox [formControl]="superCtrl">Super</mat-checkbox>
            <mat-checkbox [formControl]="adblueCtrl">AdBlue</mat-checkbox>
            <mat-checkbox [formControl]="betriebSonstCtrl">Übriger Betrieb</mat-checkbox>
            <kiene-csv-export
                [columns]="csvDetailColumns"
                [data]="detailDataSource.data"
                [filename]="csvDetailFilename"
            ></kiene-csv-export>
        </div>
        <table mat-table [dataSource]="detailDataSource" matSort #detailSort="matSort">
            <ng-container matColumnDef="detail_kennzeichen">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kennzeichen</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kennzeichen }}</td>
            </ng-container>
            <ng-container matColumnDef="detail_bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Bezeichnung</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.bezeichnung }}</td>
            </ng-container>
            <ng-container matColumnDef="detail_kostenstelle_suffix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Suffix</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kostenstelle_suffix }}</td>
            </ng-container>
            <ng-container matColumnDef="detail_netto_4530">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4530 Betrieb</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="detail_netto_4530_diesel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Diesel</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530_diesel | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="detail_netto_4530_super">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Super</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530_super | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="detail_netto_4530_adblue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">AdBlue</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530_adblue | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="detail_netto_4530_sonst">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Betrieb sonst.</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530_sonst | number: "1.2-2" }} &euro;</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedDetailColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedDetailColumns"></tr>
        </table>
        <div
            *ngIf="!loading && detailDataSource.data.length === 0"
            style="padding: 24px; color: #888; text-align: center"
        >
            Keine Betriebskosten (4530) im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-top: 24px">
        <div class="one-row" style="align-items: center; gap: 16px; flex-wrap: wrap; padding: 8px 0">
            <span style="font-weight: 500">Abgleich Kfz-Kosten / Abgabebelege</span>
            <span style="color: #888; font-size: 0.9em">
                Abgeschlossene Abgabebelege des zugeordneten Tierarztes im Zeitraum. Mehrere Fahrzeuge desselben
                Tierarztes teilen Belege und Umsatz anteilig.
            </span>
            <span class="spacer"></span>
            <kiene-csv-export
                [columns]="csvAbgleichColumns"
                [data]="abgleichDataSource.data"
                [filename]="csvAbgleichFilename"
            ></kiene-csv-export>
        </div>
        <table class="report-ergebnis-table" *ngIf="summen" style="margin-top: 0">
            <thead>
                <tr>
                    <th>Kfz-Kosten</th>
                    <th>Abgabebelege</th>
                    <th>Umsatz Abgabebelege</th>
                    <th>Kfz je Beleg</th>
                    <th>Umsatz je Beleg</th>
                    <th>Kfz % vom Umsatz</th>
                </tr>
            </thead>
            <tbody>
                <tr style="font-size: 1.4em; font-weight: bold; color: green">
                    <td>{{ summen.netto_gesamt | number: "1.2-2" }} &euro;</td>
                    <td>{{ summen.abgabebelege_anzahl | number: "1.0-0" }}</td>
                    <td>{{ summen.abgabebelege_umsatz | number: "1.2-2" }} &euro;</td>
                    <td>{{ summen.kosten_je_abgabebeleg | number: "1.2-2" }} &euro;</td>
                    <td>{{ summen.umsatz_je_abgabebeleg | number: "1.2-2" }} &euro;</td>
                    <td>{{ summen.kfz_am_umsatz_prozent | number: "1.1-1" }} %</td>
                </tr>
            </tbody>
        </table>
        <table mat-table [dataSource]="abgleichDataSource" matSort #abgleichSort="matSort">
            <ng-container matColumnDef="abgleich_kennzeichen">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kennzeichen</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kennzeichen }}</td>
            </ng-container>
            <ng-container matColumnDef="abgleich_bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Bezeichnung</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.bezeichnung }}</td>
            </ng-container>
            <ng-container matColumnDef="abgleich_tierarzt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Tierarzt</th>
                <td mat-cell *matCellDef="let e" class="number">
                    {{ e.tierarzt }}
                    <span *ngIf="e.fahrzeuge_des_ta > 1" style="color: #888"> ({{ e.fahrzeuge_des_ta }} Fzg.)</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="abgleich_netto_gesamt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kfz-Kosten</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_gesamt | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="abgleich_abgabebelege_anzahl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Abgabebelege</th>
                <td mat-cell *matCellDef="let e" class="number">
                    {{ e.abgabebelege_anzahl | number: "1.0-1" }}
                    <span *ngIf="e.fahrzeuge_des_ta > 1" style="color: #888"> / {{ e.abgabebelege_ta }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="abgleich_abgabebelege_umsatz">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Umsatz</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.abgabebelege_umsatz | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="abgleich_kosten_je_abgabebeleg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kfz / Beleg</th>
                <td mat-cell *matCellDef="let e" class="number">
                    {{ e.kosten_je_abgabebeleg | number: "1.2-2" }} &euro;
                </td>
            </ng-container>
            <ng-container matColumnDef="abgleich_umsatz_je_abgabebeleg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Umsatz / Beleg</th>
                <td mat-cell *matCellDef="let e" class="number">
                    {{ e.umsatz_je_abgabebeleg | number: "1.2-2" }} &euro;
                </td>
            </ng-container>
            <ng-container matColumnDef="abgleich_kfz_am_umsatz_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kfz % Umsatz</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kfz_am_umsatz_prozent | number: "1.1-1" }} %</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedAbgleichColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedAbgleichColumns"></tr>
        </table>
        <div
            *ngIf="!loading && abgleichDataSource.data.length === 0"
            style="padding: 24px; color: #888; text-align: center"
        >
            Keine Fahrzeuge mit Kosten oder Abgabebelegen im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-bottom: 24px; margin-top: 24px; height: 600px" *ngIf="chartHasData">
        <google-chart
            style="width: 100%"
            [type]="chartType"
            [columns]="chartColumns"
            [data]="chartData"
            [height]="600"
            [options]="{ pieHole: 0.4, title: 'Fahrzeugkosten' }"
        >
        </google-chart>
    </mat-card>
</div>
